// import Outbox from './Outbox';

export default {
  priority: 2,
  permissions: ['RequestsMenu/Box/SentMenu'],
  // component: Outbox,
  component: load(() => import(/* webpackChunkName: "Requests-Outbox" */ './Outbox')),
  name: app.translate('routes.home.requests.Outbox'),
  icon: 'inbox-arrow-up',
  drawer: true,
};


